<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YDiLEB/tc-custom/9781649217035.jpg?1706126757905" alt="This image is the cover for the book Battle Digest: Desert Storm, Battle Digest"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle Digest: Desert Storm, Battle Digest
      </h1>
      <p class="bookDescription body article font2">
        <b>A concise guide to the American-led coalition’s speedy defeat of Saddam Hussein in 1991, with maps, facts, historical significance, and more.</b><br/><br/>Just two years after the end of Iraq’s war with Iran, an emboldened Iraqi dictator, Saddam Hussein, invaded Kuwait. Operation Desert Storm was the final phase of the U.S.-led Coalition’s effort to expel Saddam’s forces from his southern neighbor’s borders. In less than 100 hours of joint air and ground combat, the U.S. and its allies would not only triumph, but also demonstrate to the world the superiority of a new breed of weapons. The battle also had the unintended effect of renewing a pride and confidence in the U.S. military after the long shadow of Vietnam.<br/><br/>Learn how America built a coalition of nations to go to war, and how Gen. Norman Schwarzkopf used maneuver and deception to create one of the most lopsided victories in the history of warfare.<br/><br/>The Battle Digest summary includes all the key aspects of the campaign and battle, including maps, images, and lessons learned.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher J. Petty
      </h2>
      
      <p class="authorDescription body article">Christopher J. Petty is a retired Army Brigadier General, a graduate of West Point, and the U.S. Army War College. His career spanned multiple commands, including combat operations during the Iraq "Surge" and a NATO command in Bosnia. Chris's unique blend of three decades of military experience, love of history, and a passion for understanding the timeless lessons of war, make Battle Digest a unique, time-saving, and powerful resource.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ed86ebc